import { useLocale } from '@/i18n/locale-context';
import { PageHeader, Placeholder, Section } from './page-parts';
import { SkeletonText } from '@/components/ui';
import type { TranslationKey } from '@nk/shared';

/**
 * About, contact, privacy, terms, advertise — the publication's own pages. They are CMS
 * content (PRD §19 site settings), not code, so Phase 14 gives an editor a screen for
 * them; this is the frame and the route.
 */
export default function StaticPage({ titleKey }: { titleKey: TranslationKey }) {
  const { t } = useLocale();
  return (
    <Placeholder phase="14">
      <PageHeader title={t(titleKey)} />
      <Section>
        <SkeletonText lines={6} className="max-w-2xl" />
      </Section>
    </Placeholder>
  );
}
